export default class Callbacks{

	static cardCallback(input, value, valid){

        if(valid) input.value = value.replace(/(\d{4})/g, '$1 ').replace(/\s{2,}/g,' ').trim();

    }

    static nameCallback(input, value, valid){

        if(valid) input.value = Callbacks.ucfirst(value.trim().toLowerCase());

    }

    static phoneCallback(input, value, valid){

        input.value = value.replace(/[^0-9]/g, '');

        // Format the phone
        if(input.value.length == 10)
            input.value = '(' + input.value.substring(0 ,3) + ') ' + input.value.substring(3, 6) + '-' + input.value.substring(6, 10);

    }

    static zipCodeCallback(input, value, valid){

        if(!valid) return;

        value = value.toUpperCase();
        if(value.length == 6) value = value.slice(0,3) + " " + value.slice(-3);
        input.value = value;

    }

    static ucfirst(string){

	    // Not a string
	    if(typeof string != 'string')
	        return null;

	    return string.charAt(0).toUpperCase() + string.substr(1);

	}
}

